// Use an immutable unique key: OFFSET repeats authorization work for rows from
// previous pages and an unordered range can repeat or omit records.
export async function fetchAllById(query: () => any, signal?: AbortSignal) {
  const key = 'id';
  // Keep each page within the database deadline when RLS checks each enrollment.
  const pageSize = 250;
  const data: any[] = [];
  let cursor: string | undefined;
  for (;;) {
    let page = query().order(key, { ascending: true }).limit(pageSize).abortSignal(signal ?? AbortSignal.timeout(30_000));
    if (cursor) page = page.gt(key, cursor);
    const result = await page;
    if (result.error) return { data: null, error: result.error };
    const rows = result.data;
    const valid = Array.isArray(rows) && rows.every((row, index) => {
      const value = row?.[key], previous = index ? rows[index - 1]?.[key] : cursor;
      return typeof value === 'string' && (previous === undefined || value > previous);
    });
    if (!valid) {
      return { data: null, error: { code: 'INVALID_RESPONSE', message: 'Invalid paginated response' } };
    }
    data.push(...rows);
    if (rows.length < pageSize) return { data, error: null };
    cursor = rows[rows.length - 1][key];
  }
}

// Bound URL size while retaining all rows when a unit has many olympiads.
export async function fetchForIds(query: () => any, column: string, ids: string[], signal?: AbortSignal) {
  const data: any[] = [];
  for (let start = 0; start < ids.length; start += 100) {
    const result = await fetchAllById(() => query().in(column, ids.slice(start, start + 100)), signal);
    if (result.error) return result;
    data.push(...result.data!);
  }
  return { data, error: null };
}
